'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var makeStyles = {};

exports.__exports = makeStyles;
